import type { FeatureGroup } from '../../../types';
import { CRM_INTEGRATIONS_FEATURE_GROUP } from '../group';

export const SETTINGS_FEATURE_GROUP: FeatureGroup = {
  guid: '3d12b9ef-6a96-4b5d-8d78-004ae25bff00',
  name: 'settings',
  description: 'Configure global options for Altru integrations',
  product: 'app',
  parentGuid: CRM_INTEGRATIONS_FEATURE_GROUP.guid,
};
